export default __webpack_public_path__ + "static/media/sampleMapLocation2.7dfb1889.png";